import React from 'react';
import isNil from 'lodash/isNil';
import {
  EligibilityOverviewPlan,
} from 'dtos/eligibilityOverviewPlan';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import Field from 'views/EMR/components/Eligibility/Overview/Field';

type Props = {
  plan: EligibilityOverviewPlan;
};

export default function Plan({ plan }: Props) {
  const {
    planName,
    planNumber,
    insuranceTypes,
    groupNumber,
    groupDescription,
    planDate,
  } = plan;

  return (
    <Section title="Plan">
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <Field label="Plan names" value={planName} />
        <Field label="Plan number" value={planNumber} />
        {!isNil(insuranceTypes) && insuranceTypes.length > 0 && (insuranceTypes.length > 1 ? (
          <div className="flex flex-col gap-0.5 min-w-[130px]">
            <span className="text-xs text-gray-500">Insurance types</span>
            <ul className="list-disc list-inside text-xs font-semibold text-gray-700">
              {insuranceTypes.map((type) => (
                <li key={type}>{type}</li>
              ))}
            </ul>
          </div>
        ) : (
          <Field label="Insurance type" value={insuranceTypes[0]} />
        ))}
        <Field label="Group number" value={groupNumber} />
        <Field label="Group description" value={groupDescription} />
        <Field label="Plan date" value={planDate} />
      </div>
    </Section>
  );
}
